export default __webpack_public_path__ + "static/media/makediffer.3173199d.gif";